import { Product } from "components/product/product.types";
import { POWERON_PRO_FEATURES, POWERON_PRO_PLAN } from "./poweron-pro";
import { NEXUM_API_FEATURES, NEXUM_API_PLAN } from "./nexum";
import { GLACI_FEATURES, GLACI_PLAN } from "./glaci";

export const PRODUCTS: Product[] = [{
  id: 'poweron-pro',
  features: [...POWERON_PRO_FEATURES],
  plan: POWERON_PRO_PLAN,
}, {
  id: 'nexum-api',
  features: [...NEXUM_API_FEATURES],
  plan: NEXUM_API_PLAN,
}, {
  id: 'glaci',
  features: [...GLACI_FEATURES],
  plan: GLACI_PLAN,
}];
